import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";

// !!! must import xds css before any other css files
import "./i18n-index";
import "./index.css";

import { AppIndex } from "./AppIndex";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <BrowserRouter>
    <AppIndex />
  </BrowserRouter>
);
